import { Box } from '@mui/joy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SlidingPanel, SlidingPanelContent } from 'core/components';
import { IPartFinderSelection } from 'partFinder/types';
import { Size } from 'theme/enums';

import { PartFinderFamilySearch } from './PartFinderFamilySearch';

interface IProps {
  familyId: number | null;
  initialSelection: IPartFinderSelection;
  onClose: () => void;
}

// The family's filter page in a drawer, opened from the catalog's Source column.
export const PartFinderFamilyDrawer = ({ familyId, initialSelection, onClose }: IProps) => {
  // The drawer's sticky header, which takes the family's name and part count.
  const [heading, setHeading] = useState<HTMLDivElement | null>(null);

  const { t } = useTranslation();

  return (
    <SlidingPanel
      isOpen={familyId !== null}
      onClosePanel={onClose}
      title={t('titlePartFinderCatalog')}
      subtitle={t('subtitlePartFinderCatalog')}
      extra={<Box ref={setHeading} />}
      size={Size.LG}
    >
      {/* fullWidth sizes the content for a full-width panel (a fixed 1,440px), wider than this
          drawer, so the drawer would scroll sideways. */}
      <SlidingPanelContent fullWidth={false}>
        {familyId !== null && (
          <PartFinderFamilySearch
            familyId={familyId}
            isDrawer
            headingContainer={heading}
            initialSelection={initialSelection}
            onClose={onClose}
          />
        )}
      </SlidingPanelContent>
    </SlidingPanel>
  );
};
